const buildFiltersFromParam = (setActiveFilters, urlParams, fieldsList = []) => {
    fieldsList = [...fieldsList, 'keyword-search', 'page'];
    const newActiveFilters = {};
    const params = urlParams ?? window.location.href.split("?")[1];
    if (params) {
        const filters = params.split('&');
        filters.forEach(filter => {
            let key = filter.split('=')[0];
            let values = filter.split('=')[1];
            
            // Only filter with available fields.
            if (!fieldsList.includes(key)) return;
            if (key === 'page' && (isNaN(+values) || +values < 1)) values = '1';
            values = values.split(';');
            newActiveFilters[key] = []
            values.length > 1
                ? values.forEach(v => {
                    if (v) newActiveFilters[key].push(decodeURI(v))
                })
                : newActiveFilters[key] = decodeURI(values[0])
        })
    }
    setActiveFilters(newActiveFilters)
}

const buildESQueryBody = (activeFilters, size = 24, storeSettings) => {
    let criteria = {query: {bool: {must: []}}, size: size};
    let aggsFilters = {};

    for (const filter in activeFilters) {
        let bool;
        if (filter === 'sort') criteria.sort = {[activeFilters[filter][0]]: activeFilters[filter][1]}
        else if (filter === 'page') criteria.from = (activeFilters[filter] - 1) * size;
        else if (filter.includes('-min') || filter.includes('-max')) {
            let id = filter.split('-');
            const minMax = id.pop() === 'min' ? 'gte' : 'lte';
            bool = {must: {range: {[id.join('-')]: {[minMax]: activeFilters[filter]}}}};
        } else if (filter.includes('keyword-search')) bool = {
            should: {
                multi_match: {
                    query: activeFilters[filter],
                    type: 'cross_fields',
                    operator: "and",
                    fields: ["title", ...storeSettings?.fields?.search]
                }
            }
        };
        else if (filter.includes('discount')) bool = {must: {range: {discountedSellingPrice: {gte: 0}}}}
        else {
            bool = {should: [], minimum_should_match: 1}
            const name = (['make', 'family', 'variant'].includes(filter)) ? `${filter}.keyword` : filter;
            if (Array.isArray(activeFilters[filter])) {
                activeFilters[filter].forEach((value) => {
                    bool.should.push({match_phrase: {[name]: value}})
                })
            } else {
                bool.should.push({match_phrase: {[name]: activeFilters[filter]}})
            }
        }

        if (bool) {
            criteria.query.bool.must.push({bool})
            aggsFilters[filter] = {bool};
        }
    }

    return {criteria, aggsFilters}
}

module.exports ={
    buildFiltersFromParam,
    buildESQueryBody
}